import React from "react";

export default function TextareaField({ field, value, onChange }) {
  const display = field.json && value && typeof value !== "string" ? JSON.stringify(value, null, 2) : (value ?? "");
  const handle = e => {
    const raw = e.target.value;
    if (!field.json) return onChange(field.name, raw);
    try { onChange(field.name, raw ? JSON.parse(raw) : {}); }
    catch { onChange(field.name, raw); } // keep raw; server validates
  };
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>
      <textarea className={`mp-form-input pt-form-textarea${field.json ? " pt-form-textarea--code" : ""}`} rows={4} value={display} onChange={handle} />
    </div>
  );
}
